import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../core";
import { CouponCodeDisplayDto, CouponValidateCodePostDto } from "../dto";

@Injectable({ providedIn: "root" })
export class CouponService {
  protected serviceUrl = "Coupon";

  constructor(protected api: ApiService) {}

  getByCode(code: string): Observable<CouponCodeDisplayDto[]> {
    return this.api.post<CouponCodeDisplayDto[]>(`${this.serviceUrl}/byCode`, { code });
  }

  validateByCode(payload: CouponValidateCodePostDto): Observable<void> {
    return this.api.post<void>(`${this.serviceUrl}/code/validate`, payload);
  }
}
